<div #panel *ngIf="creating && panelData" class="gauge-panel alignRow alignColumn">
    <!-- [title]="(panelData.title || panelData.nodeData.Name) ?? 'Add Node'" -->
    <div class="text-panel-title alignRow">
        <span>{{(panelData.title || panelData.nodeData.Name)}} </span>
        <mat-icon [matMenuTriggerFor]="titleMenu" [matMenuTriggerData]="{panelData: panelData}">edit</mat-icon>
    </div>
    <div class="container"
        [ngStyle]="{'grid-template-columns': panelData.totalise ? '1fr' : '1fr '.repeat(panelData.datapoints.length)}">
        <ng-container *ngIf="panelData.totalise" [ngTemplateOutlet]="gauge_example"
            [ngTemplateOutletContext]="{index: 0, DPTitle: ''}" />
        <ng-container *ngIf="!panelData.totalise">
            <ng-container *ngFor="let dp of panelData.datapoints; let dpIdx = index;" [ngTemplateOutlet]="gauge_example"
                [ngTemplateOutletContext]="{index: dpIdx, DPTitle: dp.DPTitle, datapoint: dp}"></ng-container>
        </ng-container>
    </div>
    <ng-template #gauge_example let-idx="index" let-DPTitle="DPTitle" let-datapoint="datapoint">
        <div class="gauge-legend alignColumn">
            <div class="new-gauge">
                <ejs-circulargauge #gauge background="transparent" style="height: 100%; width: 100%;" #circulargauge=''>
                    <e-axes>
                        <e-axis radius='100%' startAngle=200 endAngle=160 [minimum]="getAxisMaxMinForRanges(idx).min"
                            [maximum]="getAxisMaxMinForRanges(idx).max" [showLastLabel]="true"
                            [majorTicks]='{height: 0, width: 0, interval: getAxisMaxMinForRanges(idx).interval}'
                            [labelStyle]='labelStyleNew' [lineStyle]='lineStyle' [annotations]='annotations'
                            [minorTicks]="{height: 0}" [interval]="getAxisMaxMinForRanges(idx).interval">
                            <e-ranges *ngIf="panelData.ranges">
                                <ng-container *ngIf="!isPointerType">
                                    <e-range [start]="getAxisMaxMinForRanges(idx).min"
                                        [end]="getAxisMaxMinForRanges(idx).max" radius='90%' [startWidth]="rangeWidth"
                                        [endWidth]="rangeWidth" color='#E0E0E0' [roundedCornerRadius]="0">
                                    </e-range>
                                    <ng-container *ngFor="let range of panelData.ranges; let rangeIdx = index;">
                                        <e-range *ngIf="testingValue > range.min[idx]" [start]="range.min[idx]"
                                            [end]="Math.min(range.max[idx], testingValue)" radius='90%'
                                            [startWidth]="rangeWidth" [endWidth]="rangeWidth"
                                            [color]="range.color[idx] || defaultRangeColours[rangeIdx]"
                                            [roundedCornerRadius]="0">
                                        </e-range>
                                        <e-range [start]="range.min[idx]" [end]="range.max[idx]" radius='90%'
                                            [startWidth]="rangeWidth" [endWidth]="rangeWidth"
                                            [color]="range.color[idx] || defaultRangeColours[rangeIdx]"
                                            [roundedCornerRadius]="0" [opacity]="0.25">
                                        </e-range>
                                    </ng-container>
                                </ng-container>
                            </e-ranges>
                            <e-pointers>
                                <e-pointer [animation]="{enable: false}" [value]="testingValue" [type]="'Marker'"
                                    radius="90%" [markerShape]="'InvertedTriangle'"
                                    [color]="resolveRangeColour(testingValue, idx)" [markerHeight]="10"
                                    [markerWidth]="10" [pointerWidth]="rangeWidth" [border]="{width: 0}">
                                </e-pointer>
                            </e-pointers>
                            <e-annotations>
                                <e-annotation radius="0%" [content]="annotationTemplate" [angle]="0"
                                    [zIndex]="1"></e-annotation>
                            </e-annotations>
                            <ng-template #annotationTemplate>
                                <div class="gauge-annotation">
                                    <span>{{testingValue}}</span>
                                    <span class="smaller-text">{{datapoint ? datapoint.SI : ''}}</span>
                                </div>
                            </ng-template>
                        </e-axis>
                    </e-axes>
                </ejs-circulargauge>
                <span>{{DPTitle}}</span>
            </div>
        </div>
    </ng-template>
</div>

<div #panel *ngIf="creating && !panelData" class="gauge-panel alignRow alignColumn">
    <div class="text-panel-title alignRow">
        <span>Annotated Gauge</span>
    </div>
    <div class="gauge-legend alignColumn" style="grid-template-columns: 1fr;">
        <div class="new-gauge">
            <ejs-circulargauge #gauge background="transparent" style="height: 100%; width: 100%;" #circulargauge=''>
                <e-axes>
                    <e-axis radius='100%' startAngle=200 endAngle=160 [minimum]="0" [maximum]="100"
                        [showLastLabel]="true" [majorTicks]='{height: 0, width: 0, interval: 100}'
                        [labelStyle]='labelStyleNew' [lineStyle]='lineStyle' [annotations]='annotations'
                        [minorTicks]="{height: 0}" [interval]="100">
                        <e-ranges>
                            <ng-container *ngIf="!isPointerType">
                                <e-range [start]="0" [end]="100" radius='90%' [startWidth]="rangeWidth"
                                    [endWidth]="rangeWidth" color='#E0E0E0' [roundedCornerRadius]="0">
                                </e-range>
                                <ng-container>
                                    <e-range [end]="30" radius='90%' [startWidth]="rangeWidth" [start]="0"
                                        [endWidth]="rangeWidth" [color]="'green'" [roundedCornerRadius]="0">
                                    </e-range>
                                    <e-range [end]="70" radius='90%' [startWidth]="rangeWidth" [start]="30"
                                        [endWidth]="rangeWidth" [color]="'orange'" [roundedCornerRadius]="0">
                                    </e-range>
                                    <e-range [end]="85" radius='90%' [startWidth]="rangeWidth" [start]="70"
                                        [endWidth]="rangeWidth" [color]="'red'" [roundedCornerRadius]="0">
                                    </e-range>
                                    <e-range [end]="30" radius='90%' [startWidth]="rangeWidth" [start]="0"
                                        [endWidth]="rangeWidth" [color]="'green'" [roundedCornerRadius]="0"
                                        [opacity]="0.25">
                                    </e-range>
                                    <e-range [end]="70" radius='90%' [startWidth]="rangeWidth" [start]="30"
                                        [endWidth]="rangeWidth" [color]="'orange'" [roundedCornerRadius]="0"
                                        [opacity]="0.25">
                                    </e-range>
                                    <e-range [end]="100" radius='90%' [startWidth]="rangeWidth" [start]="70"
                                        [endWidth]="rangeWidth" [color]="'red'" [roundedCornerRadius]="0"
                                        [opacity]="0.25">
                                    </e-range>
                                </ng-container>
                            </ng-container>
                        </e-ranges>
                        <e-pointers>
                            <e-pointer [animation]="{enable: false}" [value]="85" [type]="'Marker'" radius="90%"
                                [markerShape]="'InvertedTriangle'" [color]="'red'" [markerHeight]="10"
                                [markerWidth]="10" [pointerWidth]="rangeWidth" [border]="{width: 0}">
                            </e-pointer>
                        </e-pointers>
                        <e-annotations>
                            <e-annotation radius="0%" [content]="annotationTemplate" [angle]="0"
                                [zIndex]="1"></e-annotation>
                        </e-annotations>
                        <ng-template #annotationTemplate>
                            <div class="gauge-annotation">
                                <span>85</span>
                                <span class="smaller-text">°C</span>
                            </div>
                        </ng-template>
                    </e-axis>
                </e-axes>
            </ejs-circulargauge>
            <span>Example Datapoint - Temperature</span>
        </div>
    </div>
</div>

<div #panel *ngIf="!creating && publicPanelData[panelData.id] && isNewGauge" class="gauge-panel alignRow alignColumn">
    <div class="text-panel-title alignRow">
        <span>{{!publicPanelData[panelData.id] ? 'Loading...' : panelData.title || panelData.nodeData.Name}}</span>
    </div>
    <div class="container"
        [ngStyle]="{'grid-template-columns': panelData.totalise ? '1fr' : '1fr '.repeat(panelData.datapoints.length)}">
        <ng-container *ngIf="panelData.totalise" [ngTemplateOutlet]="gauge_example"
            [ngTemplateOutletContext]="{index: 0, DPTitle: ''}" />
        <ng-container *ngIf="!panelData.totalise">
            <ng-container *ngFor="let dp of panelData.datapoints; let dpIdx = index;" [ngTemplateOutlet]="gauge_example"
                [ngTemplateOutletContext]="{index: dpIdx, DPTitle: dp.DPTitle, datapoint: dp}"></ng-container>
        </ng-container>
    </div>
    <ng-template #gauge_example let-idx="index" let-DPTitle="DPTitle" let-datapoint="datapoint">
        <div class="gauge-legend alignColumn">
            <div class="new-gauge">
                <ejs-circulargauge class="_circular-gauge-{{idx}} _circ-gauge" #gauge background="transparent"
                    style="height: 100%; width: 100%;" [ngStyle]="{'height': !panelData.totalise ? '90%' : '100%'}" #circulargauge='' [tooltip]="tooltip"
                    (tooltipRender)="tooltipRender($event, idx)">
                    <e-axes>
                        <e-axis radius='100%' startAngle=200 endAngle=160
                            [minimum]="axisConfig.length > 0 ? axisConfig[idx].min : 0"
                            [maximum]="axisConfig.length > 0 ? axisConfig[idx].max : 100" [showLastLabel]="false"
                            [majorTicks]='majorTicks[idx]' [labelStyle]='labelStyleNew' [lineStyle]='lineStyle'
                            [annotations]='annotations' [minorTicks]="{height: 0}"
                            [interval]="axisConfig.length > 0 ? axisConfig[0].interval : 0">
                            <e-ranges *ngIf="panelData.ranges">
                                <ng-container *ngIf="!isPointerType">
                                    <e-range [start]="axisConfig.length > 0 ? axisConfig[idx].min : 0"
                                        [end]="axisConfig.length > 0 ? axisConfig[idx].max : 100" radius='90%'
                                        [startWidth]="rangeWidth" [endWidth]="rangeWidth" color='#E0E0E0'
                                        [roundedCornerRadius]="0">
                                    </e-range>
                                    <ng-container *ngFor="let range of panelData.ranges; let rangeIdx = index;">
                                        <e-range
                                            *ngIf="(publicPanelData[panelData.id] ? publicPanelData[panelData.id].numberMetrics[idx] : 0) > range.min[idx]"
                                            [start]="range.min[idx]"
                                            [end]="Math.min(range.max[idx], (publicPanelData[panelData.id] ? publicPanelData[panelData.id].numberMetrics[idx] : 0))"
                                            radius='90%' [startWidth]="rangeWidth" [endWidth]="rangeWidth"
                                            [color]="range.color[idx] || defaultRangeColours[rangeIdx]"
                                            [roundedCornerRadius]="0">
                                        </e-range>
                                        <e-range [start]="range.min[idx]" [end]="range.max[idx]" radius='90%'
                                            [startWidth]="rangeWidth" [endWidth]="rangeWidth"
                                            [color]="range.color[idx] || defaultRangeColours[rangeIdx]"
                                            [roundedCornerRadius]="0" [opacity]="0.25">
                                        </e-range>
                                    </ng-container>
                                </ng-container>
                            </e-ranges>
                            <e-pointers>
                                <ng-container *ngIf="!isPointerType">
                                    <e-pointer [animation]="{enable: false}"
                                        [value]="publicPanelData[panelData.id] ? publicPanelData[panelData.id].numberMetrics[idx] : 0"
                                        [type]="'Marker'" radius="90%" [markerShape]="'InvertedTriangle'"
                                        [color]="resolveRangeColour(publicPanelData[panelData.id] ? publicPanelData[panelData.id].numberMetrics[idx] : 0, idx)"
                                        [markerHeight]="10" [markerWidth]="10" [pointerWidth]="rangeWidth"
                                        [border]="{width: 0}">
                                    </e-pointer>
                                </ng-container>

                                <ng-container *ngIf="isPointerType">
                                    <e-pointer [animation]="{enable: false}"
                                        [value]="publicPanelData[panelData.id] ? publicPanelData[panelData.id].numberMetrics[idx] : 0"
                                        [type]="'Marker'" radius="90%" [markerShape]="'InvertedTriangle'"
                                        [color]="'black'" [markerHeight]="10" [markerWidth]="10"
                                        [pointerWidth]="rangeWidth" [border]="{width: 0}">
                                    </e-pointer>
                                </ng-container>
                            </e-pointers>
                            <e-annotations>
                                <e-annotation radius="0%" [content]="annotationTemplate" [zIndex]="999"
                                    [angle]="0"></e-annotation>
                            </e-annotations>
                            <ng-template #annotationTemplate>
                                <div class="gauge-annotation">
                                    <span>{{publicPanelData[panelData.id] ?
                                        publicPanelData[panelData.id].numberMetrics[idx] : 0}}</span>
                                    <span class="smaller-text">{{datapoint ? datapoint.SI :
                                        publicPanelData[panelData.id] ?
                                        publicPanelData[panelData.id].SI :
                                        ""}}</span>
                                </div>
                            </ng-template>
                        </e-axis>
                    </e-axes>
                </ejs-circulargauge>
                @if(!panelData.totalise) {
                <div class="datapoint-name"
                    [ngClass]="{'offline-dp': (liveTimestamps[panelData.id] && liveTimestamps[panelData.id][idx]) ? liveTimestamps[panelData.id][idx].offline : false}">
                    <span>{{datapoint ? datapoint.SensorName : ''}}</span>
                    @if(liveTimestamps.length > 0 && liveTimestamps[panelData.id][idx]) {
                    <span [innerHTML]="liveTimestamps[panelData.id][idx].html"></span>
                    }
                </div>
                }
            </div>
        </div>
    </ng-template>
</div>

<div *ngIf="!creating && !publicPanelData[panelData.id]" class="spinner alignColumn">
    <img src="https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/circle-lines.gif">
</div>